import { VBadge } from "@/components/ui";
import type { CaseStatus } from "@/domains/cases/api/types";

const STATUS_CONFIG: Record<
  CaseStatus,
  { label: string; color: React.ComponentProps<typeof VBadge>["color"] }
> = {
  intake: { label: "Intake", color: "neutral" },
  scheduled: { label: "Ingepland", color: "info" },
  active: { label: "Lopend", color: "success" },
  closing: { label: "Afsluiten", color: "warning" },
  closed: { label: "Afgesloten", color: "secondary" },
};

type CaseStatusBadgeProps = {
  status: CaseStatus;
};

export function CaseStatusBadge({ status }: CaseStatusBadgeProps): React.JSX.Element {
  const { label, color } = STATUS_CONFIG[status];
  return <VBadge color={color}>{label}</VBadge>;
}
